import h from 'react-hyperscript';
import hh from 'hyperscript-helpers';
import PropTypes from 'prop-types';
import R from 'ramda';
import classNames from 'classnames';

import styles from './sticker.css';

const { div, p } = hh(h);

const Sticker = ({
    position,
    theme,
    text,
    size = 'medium',
    ...props
}) => {

    const containerClasses = classNames(
        styles.container,
        R.prop(`${theme}Container`, styles),
        R.prop(position, styles),
        R.prop(size, styles)
    );

    const textClasses = classNames(
        styles.text
    );

    return div({className: containerClasses}, [
        p({className: textClasses}, text)]);
};

Sticker.propTypes = {
    position: PropTypes.oneOf(['inherit', 'center', 'topRight']),
    theme: PropTypes.oneOf(['one', 'two', 'three', 'four', 'five', 'six']),
    text: PropTypes.string,
    size: PropTypes.oneOf(['small', 'medium', 'large'])
};

export default Sticker;



/** WEBPACK FOOTER **
 ** ./src/Sticker/index.js
 **/